import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloudUpload = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M22.5 19.5 21 21l-5-5v12h-2V16l-5 5-1.5-1.5L15 12zm3.5-5.417c3.444.5 6 3.445 6 6.917 0 3.861-3.139 7-7 7h-5v-2h5c2.75 0 5-2.25 5-5 0-2.528-1.833-4.528-4.278-4.944l-1.75-.25c.028-.612.056-1.25.028-1.862C23.833 9.528 20.528 6 16 6c-4.389 0-6.944 2.972-8 6.917-3.389.805-6 2.805-6 6.583C2 23.083 4.917 26 8.5 26H10v2H8.5A8.5 8.5 0 0 1 0 19.5c0-3.861 2.639-7.25 6.389-8.222A9.992 9.992 0 0 1 16 4c5.528 0 10.278 4.5 10 10z" /></svg>;
export default SvgCloudUpload;